export const separator = '::gx-go::';
